import { FC, memo } from 'react'
import { Link } from 'react-router-dom'
import { useRecentGpsPetitionsQuery } from './useRecentGpsPetitionsQuery'

import { ReactComponent as AlertIcon } from 'images/icons/flag-circle.svg'
import { ReactComponent as CheckIcon } from 'images/icons/check-circle.svg'
import { ReactComponent as LoadingIcon } from 'images/icons/clock.svg'

import styles from './RecentGpsPetitionsBox.module.scss'

const RecentGpsPetitionsBox: FC = () => {
  const { data, isLoading, isError, error } = useRecentGpsPetitionsQuery()

  if (isLoading) {
    return (
      <div className={`${styles.container} ${styles.loading}`}>
        <div className={styles.content}>
          <LoadingIcon className={styles.icon} />
          <span className={styles.text}>Checking for recent location petitions...</span>
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className={`${styles.container} ${styles.error}`}>
        <div className={styles.content}>
          <AlertIcon className={styles.icon} />
          <span className={styles.text}>
            Unable to check recent location petitions
            {error instanceof Error && `: ${error.message}`}
          </span>
        </div>
      </div>
    )
  }

  if (!data || data.total === 0) {
    return (
      <div className={`${styles.container} ${styles.success}`}>
        <div className={styles.content}>
          <CheckIcon className={styles.icon} />
          <span className={styles.text}>No pending location petitions in the last 24 hours</span>
        </div>
      </div>
    )
  }

  const getUrgencyLevel = (count: number) => {
    if (count >= 10) return 'critical'
    if (count >= 5) return 'high'
    if (count >= 2) return 'medium'
    return 'low'
  }

  const urgencyLevel = getUrgencyLevel(data.total)

  return (
    <div className={`${styles.container} ${styles[urgencyLevel]}`}>
      <div className={styles.content}>
        <AlertIcon className={styles.icon} />
        <div className={styles.textContainer}>
          <span className={styles.text}>
            <strong>{data.total}</strong> pending location petition{data.total !== 1 ? 's' : ''} in the last 24 hours
          </span>
          {data.items.length > 0 && <span className={styles.subtitle}>Most recent: {data.items[0].drop.name}</span>}
        </div>
        <Link to="/backoffice/gps-petitions?status=PENDING" className={styles.link}>
          View All
        </Link>
      </div>
    </div>
  )
}

export default memo(RecentGpsPetitionsBox)
